import { Routes } from '@angular/router';
import { UserWorkspaceComponent } from './components/user-workspace.component';
import { GroupWorkspaceComponent } from './components/group-workspace.component';
import { ManageRolesComponent } from './components/manage-roles.component';

export const customerRoutes: Routes = [
  {
    path: 'user-workspace/:key',
    component: UserWorkspaceComponent,
    data: {
      permissions: ['CustomerModule.Users:View']
    }
  },
  {
    path: 'group-workspace/:key',
    component: GroupWorkspaceComponent,
    data: {
      permissions: ['CustomerModule.Groups:View']
    }
  },
  {
    path: 'manage-roles/:key',
    component: ManageRolesComponent,
    data: {
      permissions: ['CustomerModule.Users:Edit']
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/customer/routes.config.ts